import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, message } from 'antd';
import { api } from '../../config/api';
import { useQueryClient } from '@tanstack/react-query';

const { Option } = Select;

const EditAdminForm = ({ admin, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    form.setFieldsValue(admin);
  }, [admin, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.put(`/admin/${admin.id}`, values);
      message.success('Admin updated successfully');
      
      // Invalidate queries to refresh data
      queryClient.invalidateQueries(["all-admins"]);
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error updating admin:", error);
      message.error('Failed to update admin: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      initialValues={admin} // Set initial values directly
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: 'Please input the name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please input the email!' },
          { type: 'email', message: 'Please enter a valid email!' }
        ]}
      >
        <Input readOnly/>
      </Form.Item>
      <Form.Item
        name="role"
        label="Role"
        rules={[{ required: true, message: 'Please select the role!' }]}
      >
        <Select>
          <Option value="super admin">Super Admin</Option>
          <Option value="managing admin">Managing Admin</Option>
          <Option value="lead admin">Lead Admin</Option>
          <Option value="editor">Editor</Option>
        </Select>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Update
        </Button>
        <Button onClick={onClose} style={{ marginLeft: 8 }}>
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EditAdminForm;